const nvQuiz = {
  init: function (formId) {
    const theForm = document.getElementById(formId);

    this.showContinueButtons(theForm);
  },

  showContinueButtons: function (theForm) {
    if (!theForm) return false;

    const select = theForm.querySelector('select');
    const fiveHourBtn = theForm.querySelector('#five-hour-continue');
    const eightHourBtn = theForm.querySelector('#eight-hour-continue');

    select.addEventListener('change', () => {
      document.getElementById('course-type-message').classList.remove('d-none');
      if (select.value < 3) {
        document.getElementById('course-type').innerHTML = '5-Hour Course';
        if (fiveHourBtn.classList.contains('d-none')) {
          fiveHourBtn.classList.remove('d-none');
        }
        if (!eightHourBtn.classList.contains('d-none')) {
          eightHourBtn.classList.add('d-none');
        }
      } else {
        document.getElementById('course-type').innerHTML = '8-Hour Course';
        if (!fiveHourBtn.classList.contains('d-none')) {
          fiveHourBtn.classList.add('d-none');
        }
        if (eightHourBtn.classList.contains('d-none')) {
          eightHourBtn.classList.remove('d-none');
        }
      }
    });

    window.addEventListener('pageshow', () => {
      theForm.reset();
      !document.getElementById('course-type-message').classList.contains('d-none') &&
        document.getElementById('course-type-message').classList.add('d-none');
      !fiveHourBtn.classList.contains('d-none') && fiveHourBtn.classList.add('d-none');
      !eightHourBtn.classList.contains('d-none') && eightHourBtn.classList.add('d-none');
    });
  },
};
